module.exports = __webpack_public_path__ + "img/1499347005.65dc4db0.jpg";